import { atom } from '@exodus/headless-ui';
import toAssetAtom from './to-asset.js';
const INITIAL_AMOUNT = '0';
const toAmountValue = atom(INITIAL_AMOUNT);
const toAmountAtom = atom((get) => {
    const toAmount = get(toAmountValue);
    const toAsset = get(toAssetAtom);
    return toAsset.currency.defaultUnit(toAmount);
}, (get, set, newAmount) => {
    set(toAmountValue, newAmount?.toDefaultString() ?? INITIAL_AMOUNT);
});
export default toAmountAtom;
